import { graphql, useStaticQuery } from "gatsby"

export default function useBrowserMode() {
  const result = useStaticQuery(
    graphql`
    {
        allContentfulPequeninTransversal(
          filter: {titulo: {eq: "Transversal"}}
        ) {
          nodes {
            node_locale
            tieneClubPequenin
            tieneIngresoDeClaves
          }
        }
      }
    `
  )

  const filterContentForLocale = locale =>
    result.allContentfulPequeninTransversal.nodes.filter(
      node => node.node_locale === locale
    )[0]

  const contentCountry = filterContentForLocale(process.env.LOCALE)

  return {
    haveClubPeque: contentCountry.tieneClubPequenin,
    haveClavesClub: contentCountry.tieneIngresoDeClaves,
  }
}
